import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCommentAltHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M12 6.35a3.07 3.07 0 0 0-3.54.53 3 3 0 0 0 0 4.24L11.29 14a1 1 0 0 0 1.42 0l2.83-2.83a3 3 0 0 0 0-4.24A3.07 3.07 0 0 0 12 6.35m2.12 3.36L12 11.83 9.88 9.71a1 1 0 0 1 0-1.42 1 1 0 0 1 1.41 0 1 1 0 0 0 1.42 0 1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.42M19 2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3m1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z" />
  </svg>
);
export default SvgCommentAltHeart;
